import { style } from 'typestyle'
export const w30 = style({ width: '30%' })
